import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";
import { Dispatch } from "react";
import { Microservices } from "../../../app/AllowedMicroservices";
import { RootState } from "../../../app/store";
import apiActionCreator, {
  HttpMethods,
} from "../../../services/apiActionCreator";
import { FetchStatus } from "../../common/enums";
import { IReportValue } from "../common";

interface IObjectKeyNumberValue {
  [key: string]: number;
}

interface ITicket extends IObjectKeyNumberValue {}

interface TicketCountWithCategory {
  key: string;
  value: number;
}

interface TicketsByCategoryState {
  data: TicketCountWithCategory[];
  status: FetchStatus;
}

const initialState: TicketsByCategoryState = {
  data: [],
  status: FetchStatus.Idle,
};

export const ticketsByReportTypeSlice = createSlice({
  name: "ticketsByReportType",
  initialState,
  reducers: {
    fetching: (state) => {
      state.status = FetchStatus.Fetching;
    },
    fetched: (state, action: PayloadAction<ITicket>) => {
      const payload = action.payload;
      const results: TicketCountWithCategory[] = [];
      for (let key in payload) {
        results.push({ key, value: payload[key] });
      }
      state.data = results;
      state.status = FetchStatus.Fetched;
    },
    error: (state) => {
      state.status = FetchStatus.Error;
    },
  },
});

export const { fetching, fetched, error } = ticketsByReportTypeSlice.actions;
export interface FetchCasesParams {
  from: moment.Moment;
  to: moment.Moment;
  customToken: string;
  companyId?: string;
}

export const fetchByRange =
  ({ from, to, customToken, companyId }: FetchCasesParams) =>
  (dispatch: Dispatch<object>) => {
    const fromStrDate = moment(from).format("YYYY-MM-DD");
    const toStrDate = moment(to).format("YYYY-MM-DD");
    return dispatch(
      apiActionCreator({
        endpoint: `cognizant/ticketsByReportType?from=${fromStrDate}&to=${toStrDate}${
          companyId ? `&company=${companyId}` : ""
        }`,
        types: {
          requestType: fetching,
          successTypes: [
            {
              actionOrCreator: fetched,
            },
          ],
          errorTypes: [
            {
              actionOrCreator: error,
            },
          ],
        },
        method: HttpMethods.GET,
        microservice: Microservices.X_ONE,
        authenticated: true,
        customToken,
      })
    );
  };

export const selectCaseIsFetching = (state: RootState) =>
  state.reports.case.ticketsByReportType.status === FetchStatus.Fetching;

export const selectCasesByReportTypeData = (state: RootState) => {
  const casesByReportType = state.reports.case.ticketsByReportType.data;
  return casesByReportType.map((item, index) => {
    const reportValue: IReportValue = {
      key: `${index}`,
      label: item.key,
      value: item.value,
    };
    return reportValue;
  });
};

export default ticketsByReportTypeSlice.reducer;
